import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocioConfiguracion } from '../../conexiones';
import IFlujoEtapaDocumento from './/entidades/flujoEtapaDocumento';
import IflujoEtapaDocumentoCompuesto from './entidades/flujoEtapaDocumentoCompuesto';

export default class ModeloFlujoEtapaDocumento {
    private NOMBRE_CONTROLADOR = 'FlujoEtapaDocumento';

    public consultarFlujoEtapaDocumento() {
        return manejadorRest<IRespuesta<IFlujoEtapaDocumento>>(
            () => negocioConfiguracion.get(`${this.NOMBRE_CONTROLADOR}/ConsultarListaFlujoEtapaDocumento`),
            true
        );
    }

    public editarFlujoEtapaDocumento(flujoEtapaDocumento: IFlujoEtapaDocumento) {
        return manejadorRest<IRespuesta<IFlujoEtapaDocumento>>(
            () => negocioConfiguracion.put(`${this.NOMBRE_CONTROLADOR}/EditarFlujoEtapaDocumento`, flujoEtapaDocumento),
            true
        );
    }

    public eliminarFlujoEtapaDocumento(flujoEtapaDocumento: IFlujoEtapaDocumento) {
        return manejadorRest<IRespuesta<IFlujoEtapaDocumento>>(
            () => negocioConfiguracion.delete(`${this.NOMBRE_CONTROLADOR}/EliminarFlujoEtapaDocumento`, flujoEtapaDocumento),
            true
        );
    }

    public guardarFlujoEtapaDocumento(flujoEtapaDocumento: IFlujoEtapaDocumento) {
        return manejadorRest<IRespuesta<IFlujoEtapaDocumento>>(
            () => negocioConfiguracion.post(`${this.NOMBRE_CONTROLADOR}/GuardarFlujoEtapaDocumento`, flujoEtapaDocumento),
            true
        );
    }

    public consultarFlujoEtapaDocumentoCompuesto(flujoEtapaDocumento: IFlujoEtapaDocumento) {
        return manejadorRest<IRespuesta<IflujoEtapaDocumentoCompuesto>>(
            () =>
                negocioConfiguracion.post(
                    `${this.NOMBRE_CONTROLADOR}/ConsultaListaFlujoEtapaDocumentoCompuesto`,
                    flujoEtapaDocumento
                ),
            true
        );
    }
}
